/* eslint-disable */
import apis from '@/libs/base/apis'
import weixin from '@/libs/app/weixin'
const vip = {
  state: {
    order_id: '',
    show_vip_rights: false,
    showVipPackagesToast: false,
    vipPackToastName: '',
    vip_level: null, // 当前用户购买的vip对应的pkg_id
    pkgLevel: 1, //购买vip档位
  },
  mutations: {
    CLOSE_VIP_RIGHTS (state) {
      state.show_vip_rights = false
    },
    SHOW_VIP_RIGHTS (state) {
      state.show_vip_rights = true
    },
    SET_VIP_PACKAGES_TOAST (state, payload) {
      if (!payload) {
        state.showVipPackagesToast = false
        return
      }
      state.showVipPackagesToast = true
      state.vipPackToastName = payload
    },
    SET_VIP_LEVEL (state, payload) {
      state.vip_level = payload
    },
    SET_STATE (state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    }
  },
  actions: {
    // 购买vip
    openVip ({
      state,
      commit,
      dispatch,
      rootState
    }, data) {
      let openid = rootState.openid
      let unionid = rootState.unionid
      let params = {
        pkg_id: data.memberId,
        openid: openid,
        unionid: unionid,
        pay_enter: data.pay_enter,
        pay_fee: data.pay_fee,
        page_tp: data.page_tp
      }
      if (!rootState.wxconfig) {
        weixin.init(() => {
          weixin.wxPay(params, apis.vipPay, {
            callback: data.callback,
            cancelcallback: data.cancelcallback,
            cancelCloseCallBack: data.cancelCloseCallBack,
          })
        })
        return
      }
      weixin.wxPay(params, apis.vipPay, {
        callback: data.callback,
        cancelcallback: data.cancelcallback,
        cancelCloseCallBack: data.cancelCloseCallBack,
      })
    },
    // 购买vip
    experimentVip ({
      state,
      commit,
      dispatch,
      rootState
    }, data) {
      let openid = rootState.openid
      let unionid = rootState.unionid
      let params = {
        openid: openid,
        unionid: unionid,
        pay_enter: data.pay_enter,
        pay_fee: '590'
      }
      weixin.wxPay(params, apis.vipExperiment, {
        callback: data.callback,
        cancelcallback: data.cancelcallback,
        cancelCloseCallBack: data.cancelCloseCallBack,
      })
    },
    openOneVip ({
      state,
      commit,
      dispatch,
      rootState
    }, data) {
      let params = {
        pkg_id: data.memberId,
        openid: rootState.openid,
        unionid: rootState.unionid,
        pay_enter: data.pay_enter,
        pay_fee: data.pay_fee,
        page_tp: data.page_tp
      }
      weixin.wxPay(params, apis.vipCrabPay, {
        callback: data.callback,
        cancelcallback: data.cancelcallback,
        cancelCloseCallBack: data.cancelCloseCallBack,
      })
    }
  }
}

export default vip
